import React from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Box } from '@mui/material';
import AddTaskTemplate from './AddTaskTemplate';
import AddCenturyTemplates from './AddCenturyTemplates';
import TemplateHeader from './TemplateHeader';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 1 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const Index = () => {
  const [value, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label='opportunity'
            variant='scrollable'
            scrollButtons='auto'
          >
            <Tab label='All Templates' {...a11yProps(0)} />
            <Tab label='New Project Task Templates' {...a11yProps(1)} />
            <Tab label='New 21st Century Skills Templates' {...a11yProps(2)} />
          </Tabs>
        </Box>

        <TabPanel value={value} index={0}>
          <TemplateHeader />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <AddTaskTemplate setValue={setValue} />
        </TabPanel>
        <TabPanel value={value} index={2}>
          <AddCenturyTemplates setValue={setValue} />
        </TabPanel>
      </Box>
    </>
  );
};

export default Index;
